const showAlert = (message) => {
  const notify = $.notify(
    { message: message },
    {
      type: "alert",
      allow_dismiss: true,
      placement: {
        align:"center"
      },
      animate: {
        enter: "tw-animate-[bounce_1.2s_ease-out_forwards]",
        exit: "tw-animate-[bounce_1.2s_ease-out_forwards]"
      }
    }
  )
  document.addEventListener("turbo:before-visit", () => { notify.close() }, { once: true })
  document.addEventListener("turbo:before-cache", () => { notify.$ele.remove() }, { once: true })
}

// set it as window object
const nobi = window.nobi || {}
nobi.showAlert = showAlert

// export as function
export default showAlert

